<template>
    <div class="d-flex flex-column w-100">
        <span
            v-for="(item, index) in params.items"
            :key="`multi-line-header-item-${index}`"
            :class="`w-100 ${params.itemClass}`"
        >{{ item }}</span>
    </div>
</template>

<script>
export default {
    name: 'MultiLineHeader',
};
</script>